import * as React from "react";
import "../styles/NavBar.css";
import myAvatar from "../img/profile.png";
import myStamp from "../img/my-stamp.png";
import SocialIcons from "./SocialIcons";
import UseScroll from "./UseScroll";
import { Avatar } from "@mui/material";

import { FaPhoneSquare } from "react-icons/fa";

function NavBar() {
  const [navClassList, setNavClassList] = React.useState([]);
  const scroll = UseScroll();

  React.useEffect(() => {
    const _classList = [];

    if (scroll.y > 150 && scroll.y - scroll.lastY > 0)
      _classList.push("nav-bar--hidden");

    setNavClassList(_classList);
  }, [scroll.y, scroll.lastY]);

  return (
    <div className={`nav-bar-container ${navClassList.join(" ")}`}>
      <div className="nav-bar-icons-container">
        <Avatar alt="Mike" src={myAvatar} sx={{ width: 66, height: 66 }} />
        <img alt="stamp" src={myStamp} style={{ width: 70, height: 55 }} />
      </div>

      <div className="nav-bar-icons-container">
        <SocialIcons
          name="cell-phone"
          link="tel:+18628498300"
          icon={<FaPhoneSquare fontSize={25} />}
        />
      </div>
    </div>
  );
}
export default NavBar;
